<template>
  <div class="container-fluid">
    <div>
      <div class="card">
        <div class="card-header">
          <div class="row">
            <div class="col col-xs-2">
              <h4 class="panel-title">
                <span class="title">Registro Integração</span>
                <br />
                <span class="navigation">Integração > Cadastro</span>
              </h4>
            </div>
          </div>
        </div>
        <div class="card-body">
          <div class="row d-flex align-items-end">
            <div class="col-md-2 mb-2">
              <label>Data Inicial:</label>
              <span class="p-fluid">
                <Calendar id="dataInicial" name="dataInicial" disabled="true" :showIcon="true"
                  v-model="formattedCurrentDate" dateFormat="dd/mm/yy" />
              </span>
            </div>

            <div class="col-md-2 mb-2">
              <label>Data Final: *</label>
              <span class="p-fluid">
                <Calendar id="dataFinal" name="dataFinal" v-model="integracao.dataVigenciaFinal" :showIcon="true"
                  dateFormat="dd/mm/yy" />
              </span>
            </div>
          </div>
          <div class="row d-flex align-items-end">
            <div class="col-md-4 mb-2">
              <label>Token:</label>
              <span class="p-fluid">
                <InputText type="text" disabled="true" v-model="exibirToken"></InputText>
              </span>
            </div>
          </div>
          <hr />
          <template>
            <Button @click="salvar()" label="Gerar Token" title="token" type="submit"
              class="p-button-primary mr-2 p-button-success" icon="pi pi-check" :disabled="loading">
            </Button>
          </template>
          <hr />

          <DataTable :value="integralList" :paginator="true" :rows="10" class="p-datatable-responsive" :autoLayout="true">
            <Column field="token" header="Token"></Column>
            <Column field="dataVigenciaFinalFormatada" header="Data Inativação Token"></Column>
          </DataTable>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
/* eslint-disable */
import LoginService from "../services/acesso/login.service";
import Integracao from "../models/nfse/Integracao";
import IntegracaoService from "../services/nfse/integracao.service";

export default {

  name: 'IntegracaoCadastro',
  data() {
    return {
      loading: false,
      showToken: false,
      integracao: new Integracao(),
      formattedCurrentDate: null,
      date: new Date(),
      disableToken: true,
      exibirToken: null,
      token: null,
      integralList: []
    }
  },
  created() {
    this.formatDate(this.date);
    this.currentUser = LoginService.currentUserValue;
    this.formattedCurrentDate = this.formatDate(this.date);
    this.carregarLista();
  },

  methods: {
    formatDate(date) {
      const day = String(date.getDate()).padStart(2, '0');
      const month = String(date.getMonth() + 1).padStart(2, '0');
      const year = date.getFullYear();
      return `${day}/${month}/${year}`;
    },

    onSubmit() {
      this.$validate().then((success) => {
        if (success) {
          this.salvar();
        }
      });
    },

    carregarLista() {
      IntegracaoService.findAllByCliente(
        this.currentUser.usuario.idCliente
      ).then(
        response => {
          this.integralList = response.data;
        },
        error => {
          let errorMessage = "Houve um problema listar Integrações!";
          if (error.response) {
            errorMessage = error.response.data;
          }
          this.$toast.add({
            severity: "error",
            summary: errorMessage
          });
        }
      );
    },

    salvar() {
      if (!this.integracao.dataVigenciaFinal) {
        this.$toast.add({
          severity: "warn",
          summary: 'É obrigatório o preenchimento da data final!'
        });
        return;
      }
      this.processando(true);
      this.integracao.idCliente = this.currentUser.usuario.idCliente;
      this.integracao.idUsuario = this.currentUser.usuario.idUsuario;
      console.log(this.integracao);
      IntegracaoService.saveIntegracao(
        this.integracao
      ).then(
        data => {
          this.integracao = data.data;
          console.log(this.integracao);
          console.log(data);
          this.$toast.add({
            severity: "success",
            summary: "Registro salvo com sucesso!"
          });
          this.exibirToken = this.integracao.token;
          this.limparForm();
          this.carregarLista();
        },
        error => {
          let errorMessage = "Houve um erro ao salvar o Registro!";
          if (error.response) {
            errorMessage = error.response.data;
          }
          this.$toast.add({
            severity: "error",
            summary: errorMessage
          });
        }
      );
      this.processando(false);
    },

    limparForm() {
      this.integracao.dataVigenciaFinal = '';
    },

    processando(show) {
      if (show) {
        this.loading = true;
        this.$root.$emit("loading:show");
      } else {
        this.loading = false;
        this.$root.$emit("loading:hide");
      }
    }
  },
}
</script>

<style scoped>
.p-inputtext:disabled {
  color: #a6a6a6;
  border-color: #a6a6a6;
}

textarea {
  width: 100%;
  border-radius: 12px;
}
</style>